<script setup lang="ts">
import { ref, watch, computed, useAttrs } from 'vue';

let modelValue = defineModel();
watch((modelValue),(newVal)=>{
    if(!newVal){
        if(isNaN(new Date(newVal))){
            modelValue.value = null;
        }
    }
})
let attrs = useAttrs();
let props = defineProps({
    label: {
        type: String,
        default: ''
    },
    name: {
        type: String,
        default: ''
    },
})

let focused = ref(false);
let hasValue = computed(() => {
    return modelValue.value !== null && modelValue.value !== '';
});
</script>
<template>
    <div class="input-folder input-date" :data-has-value="hasValue" :data-focused="focused">
        <!-- TODO: need solution to disable weekend days-->
        <VueDatePicker
            v-model="modelValue"
            :name="name"
            hide-input-icon
            v-bind="attrs"
            @focus="focused = true"
            @blur="focused = false"
            :enable-time-picker="false"
            text-input
            week-start="0"
            auto-apply
            :uid="name"
        />
        <label :for="`dp-input-${name}`">
            {{ label }}
        </label>
    </div>
</template>
<style lang="scss">
@import "@assets/styles/variables.scss";


</style>